<template>
  <div class="salon--option white pa-4 rounded-lg elevation-2">
    <input v-model="appointmentSalon" :value="salon.id" type="radio" :id="salon.branch_name" class="d-none" :disabled="disabled" />
    <label class="d-flex align-center justify-start" :for="salon.branch_name">
      <span class="salon--option__radio-button mr-4"></span>
      <img :width="$vuetify.breakpoint.smAndUp ? '150px' : '80px'" :height="$vuetify.breakpoint.smAndUp ? '150px' : '80px'" class="salon-image mr-4 rounded-lg" :src="salon.image" />
      <div class="salon--option__description mr-4">
        <h4 class="primary--text text--darken-1 text-body-1 font-weight-bold">
          {{ salon.branch_name }}
        </h4>
        <p>{{ salon.address }}</p>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    salon: { type: Object, required: true },
    value: { type: Number },
    disabled: { type: Boolean }
  },
  computed: {
    appointmentSalon: {
      get() {
        return this.value
      },
      set(salon) {
        this.$emit('input', salon)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.salon--option__radio-button {
  position: relative;
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  border: 1px solid var(--v-primary-darken1);
  border-radius: 99999vw;
  box-shadow: 0 2px 6px 2px var(--v-secondary-lighten5), inset -1px -1px 1px 1px rgba(var(--v-secondary-lighten5), 0.2);
  flex-grow: 0;
  flex-shrink: 0;
}

.salon--option__radio-button::before {
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  content: '';
  border-radius: 50%;
  transition: opacity 100ms ease-in;
}

.salon--option input:not(:checked) + label > .salon--option__radio-button::before {
  opacity: 0;
}

.salon--option input:checked + label > .salon--option__radio-button::before {
  @include green-gradient(90deg);
  opacity: 1;
}

.salon-image {
  object-fit: cover;
  flex-shrink: 0;
}
</style>
